/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import {
  connect
} from 'react-redux';
import { Field, FieldWrapper } from '@progress/kendo-react-form';
import content from 'utility/token_helper';
import { Error } from '@progress/kendo-react-labels';
import { CustomInput } from 'components/shared/form/custom_input';
import { CustomKendoDatePicker } from 'components/shared/form/custom_date_input';
import moment from 'moment';
import { CustomSSNInput } from 'components/shared/form/custom_ssn_input';

export function HsmvQueryFields(props) {
  const {
    errors
  } = props.formRenderProps;

  const userActionForm = (
    <div>
      <Field
        id="driversLicenseNumber"
        name="driversLicenseNumber"
        label={content('tools', 'hsmv-demo-check-drivers-license', props.categoryClientContent)}
        component={CustomInput}
        aria-label="Drivers License / State ID"
      />
      <Error>{errors?.requiredDriversLicenseNumber}</Error>
      <Error>{errors?.formatDriversLicenseNumber}</Error>
      <Field
        id="ssn"
        name="ssn"
        label={content('tools', 'hsmv-demo-check-ssn', props.categoryClientContent)}
        component={CustomSSNInput}
        aria-label="SSN"
      />
      <Error>{errors?.requiredSSN}</Error>
      <Error>{errors?.formatSSN}</Error>
      <FieldWrapper>
        <Field
          id="dob"
          name="dob"
          label={content('tools', 'hsmv-demo-check-dob', props.categoryClientContent)}
          component={CustomKendoDatePicker}
          max={moment().format('YYYY-MM-DD')}
          aria-label="DOB"
        />
      </FieldWrapper>
      <Error>{errors?.requiredDOB}</Error>
      <Error>{errors?.formatDOB}</Error>
      <Field
        id="justification"
        name="justification"
        label={content('tools', 'hsmv-demo-check-justification', props.categoryClientContent)}
        component={CustomInput}
        aria-label="justification"
        maxLength={255}
      />
      <Error>{errors?.requiredJustification}</Error>
    </div>
  );

  return (
    <div>
      {userActionForm}
    </div>
  );
}

function mapStateToProps(state) {
  return {
    categoryClientContent: state.content.categoryClientContent,
  };
}

export default connect(mapStateToProps)(HsmvQueryFields);
